import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getShouldUseOpenFilterForTeams} from '../../../../store/data/preferences/preferencesSelectors';
import {selectRefinementAction} from '../../../../store/data/refinements/refinementsActions';
import {RefinedInboxParameters} from '../../../../store/panels/inboxes/parameters/inboxesParameters';
import {ClearRefinementButton, ClearRefinementButtonVariantsEnum} from './clearRefinementButton';

/*
 * Props.
 */

interface ClearRefinementButtonContainerProps {
  parameters: RefinedInboxParameters;
  variant?: ClearRefinementButtonVariantsEnum;
  onClear?: () => void;
}

/*
 * Selectors.
 */

function getParameters(_state: AppState, props: ClearRefinementButtonContainerProps) {
  return props.parameters;
}

function getVariant(_state: AppState, props: ClearRefinementButtonContainerProps) {
  return props.variant;
}

function getOnClear(_state: AppState, props: ClearRefinementButtonContainerProps) {
  return props.onClear;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ClearRefinementButtonContainerProps>()(() => ({
  parameters: getParameters,
  shouldUseOpenFilterForTeams: getShouldUseOpenFilterForTeams,
  variant: getVariant,
  onClear: getOnClear,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  selectRefinement: selectRefinementAction,
}));

export const ClearRefinementButtonContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps) => {
    const {parameters, shouldUseOpenFilterForTeams} = stateProps;
    return {
      ...stateProps,
      onClearRefinementOption: () => {
        if (stateProps.onClear) {
          stateProps.onClear();
        }

        return dispatchProps.selectRefinement(parameters, undefined, shouldUseOpenFilterForTeams);
      },
    };
  },
)(ClearRefinementButton);
